<template>
    <section class="xnax-login">
        <div class="login-rubies">
            <p class="login-intro">Login to your Rubies account</p>
            <div class="login-form">
                <img src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/new-rubies/rubies-logo.png" alt="">

                <form @submit.prevent="setUsername">
                    <div class="row">
                        <div class="col-md-12 form-group mb-1">
                            <label for="username" class="form-label">Username</label>
                            <input
                                    type="text" class="form-input form-control" id="username" name="username"
                                    placeholder="Username" v-model="username" v-validate="'required|alpha_num'" data-vv-name="username"
                                    :class="{'is-danger': errors.has('username') }" required
                            >
                            <span v-show="errors.has('username')" class="error-span is-danger">{{ errors.first('username') }}</span>
                        </div>

                        <!--<div class="col-md-12">-->
                            <!--<default-login></default-login>-->
                        <!--</div>-->

                        <div class="col-md-12">
                            <button type="submit" class="btn btn-primary btn-xnax-login ">Continue</button>
                        </div>

                        <div class="alter-links">
                            <!--<a href="#">Forgot Password?</a>-->
                            <a @click="updateCurrentComponent('enroll')" class="mb-2">Create Account</a>
                            <a @click="updateCurrentComponent('forgot')">Forgot Password?</a>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </section>
</template>
<script>
    import {mapActions, mapGetters} from 'vuex'

    import DefaultLogin from '../utility/DefaultLogin'
    import AppUtils from "../../utils/BaseUtils/AppUtils";
    import StoreUtils from "../../utils/BaseUtils/StoreUtils";

    export default {
        name: "Login",
        components: {
            defaultLogin: DefaultLogin,
        },
        data () {
            return {
                username: '',
            }
        },
        computed: {
            ...mapGetters([
                'getAppLoading',
            ])
        },
        created () {
            AppUtils.getDeviceFingerprint()
        },
        methods: {
            ...mapActions([
                'updateCurrentComponent',
                'updateUsername',
            ]),
            setUsername(){
                this.$validator.validateAll();
                if (!this.errors.any()) {
                    // console.log('validator all check');

                    this.updateUsername(this.username);
                    this.updateCurrentComponent('pin')
                }
            },

        },
    }
</script>
<style scoped>
    .ui-modal__container {
        background-color: transparent !important;
    }
</style>